import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'ai-domain-card',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class AIDomainCard extends Vue {

    public activeDomain: any = null;

    public activeTopic: any = null;

    public activeCompetency: any = null;

    // ------------------------------------------------------
    // Properties
    @Prop()
    private domainList: any;

    private defaultDomainCode = 'F';

    public resetProperties() {
        this.activeTopic = null;
        this.activeCompetency = null;
    }

    // ------------------------------------------------------------------
    // Hooks

    public mounted() {
        const defaultDomain = this.domainList.find((item: any) => item.domainCode === this.defaultDomainCode);
        if (defaultDomain) {
            this.activeDomain = defaultDomain;
            document.querySelector(`#domain-${defaultDomain.domainSeq}`)!.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

    // ----------------------------------------------------------------------------------
    // Actions
    private onSelectDomain(domain: any) {
        this.resetProperties();
        if (this.activeDomain && this.activeDomain.domainCode === domain.domainCode ) {
            this.activeDomain = null;
        } else {
            this.activeDomain = domain;
        }
        this.$emit('onSelectLevel', this.activeDomain, this.activeTopic, this.activeCompetency);
    }

    private onSelectTopic(topic: any) {
        this.resetProperties();
        this.activeTopic = topic;
        this.$emit('onSelectLevel', this.activeDomain, this.activeTopic, this.activeCompetency);
    }

    private onSelectCompetency(competency: any) {
        this.resetProperties();
        this.activeCompetency = competency;
        this.$emit('onSelectLevel', this.activeDomain, this.activeTopic, this.activeCompetency);
    }

}
